import { List } from 'foundations-components/transitional/components/List';
import _get from 'hs-lodash/get';
import { useContext } from 'react';
import { AccountsContext } from '../../contexts/accounts/context';
import { AppContext } from '../../contexts/app/context';
import AccountListRow from './AccountListRow';
import { jsx as _jsx } from "react/jsx-runtime";
function AccountList({
  onClickRow
}) {
  const {
    appName
  } = useContext(AppContext);
  const {
    accounts
  } = useContext(AccountsContext);
  return /*#__PURE__*/_jsx(List, {
    "data-test-id": `${appName}-accounts-list`,
    wrapChildren: true,
    children: accounts.map(account => /*#__PURE__*/_jsx(AccountListRow, {
      onClick: () => onClickRow(account),
      accountName: _get(account, 'accountName', ''),
      domain: _get(account, 'domain'),
      portalId: account.portalId
    }, account.portalId))
  });
}
export default AccountList;